import {PageLoader} from "../PageLoader/PageLoader";
import React from 'react'

export const FallbackPage = () => {
    return <PageLoader/>
}